export function bySpeedChargingTypeDesc (left, right) {
    return Math.sign(left.speedChargingType - right.speedChargingType)
}
